// DevExtreme-Lokalisierung global (Spezifikation 2.1, L3) – wie bisher in TicketSale.vue (created):
// deutsche Texte laden, zwei Texte vereinheitlichen, Gebietsschema fest Deutsch (seit 13.10.2026).
// trueText/falseText bleiben unverändert (gehen in Excel-Exporte ein).
import deMessages from 'devextreme/localization/messages/de.json';
import { locale, loadMessages } from 'devextreme/localization';

const einheitlich = {
  Loading: 'Wird geladen …',
  'dxDataGrid-searchPanelPlaceholder': 'Suchen …',
  // Zeilenlink im Bearbeiten der Tabellen (z. B. Orte): „Löschen“ statt DevExtremes „Entfernen“ bzw. englisch „Delete“
  // (Kundenwunsch 13.10.2026)
  'dxDataGrid-editingDeleteRow': 'Löschen'
};

// TicketSale, Payment, Saldo und Location rufen in created() weiterhin loadMessages(deMessages) auf und würden die
// beiden Texte sonst auf „Laden...“/„Suchen...“ zurücksetzen. Darum stehen sie auch im (gemeinsam genutzten)
// Nachrichtenobjekt selbst.
try {
  Object.assign(deMessages.de, einheitlich);
} catch (e) {
  // unveränderliches Modulobjekt: dann gelten die Texte bis zum nächsten loadMessages(deMessages)
}

loadMessages(deMessages);
loadMessages({ de: einheitlich });
// immer Deutsch (Kundenwunsch 13.10.2026: „statt edit bitte bearbeiten, sind ja im deutschsprachigen raum
// unterwegs“): vorher navigator.language – bei einem englisch eingestellten Browser zeigte DevExtreme „Edit“,
// „Loading…“, „No data“ und Zahlen mit Punkt; die Verwaltung ist nur deutsch
locale('de');
